module.exports = __webpack_public_path__ + "media/images/samples/300x300/11-ba5cfd210b49b09bdcf2f42eadae52d8.jpg";